import { ronMediaArray } from './ronMedia'
import { ronBio } from './ronBios'
import { hermioneProfileReviewHinge, dumbledoreProfileReviewBumble, harryProfileReviewTinder } from './ronProfileReviews'

export const ronDatingProfileHinge = {
  _id: 'ronDatingProfileHingeId',
  userId: 'ronUserId',
  email: 'ron@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: ronMediaArray[7]._id,
      mediaItemURL: ronMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[7].type,
      caption: ronMediaArray[7].captions[0],
      subcaption: ronMediaArray[7].subcaptions[2],
    },
    {
      mediaItemId: ronMediaArray[1]._id,
      mediaItemURL: ronMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[1].type,
      caption: ronMediaArray[1].captions[0],
      subcaption: ronMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[6]._id,
      mediaItemURL: ronMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[6].type,
      caption: ronMediaArray[6].captions[0],
      subcaption: ronMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[14]._id,
      mediaItemURL: ronMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[14].type,
      caption: ronMediaArray[14].captions[2],
      subcaption: ronMediaArray[14].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[4]._id,
      mediaItemURL: ronMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[4].type,
      caption: ronMediaArray[4].captions[2],
      subcaption: ronMediaArray[4].subcaptions[1],
    },
    {
      mediaItemId: ronMediaArray[10]._id,
      mediaItemURL: ronMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[10].type,
      caption: ronMediaArray[10].captions[0],
      subcaption: ronMediaArray[10].subcaptions[1],
    }
  ],
  bio: {
    bioItemsId: ronBio._id,
    vitalInfo: { ...ronBio.vitalInfo },
    prompts: [
      { ...ronBio.prompts[0] },
      { ...ronBio.prompts[1] },
      { ...ronBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...hermioneProfileReviewHinge }
  ],
  mediaItems: [ ...ronMediaArray ],
  bioItems: { ...ronBio },
}

export const ronDatingProfileBumble = {
  _id: 'ronDatingProfileBumbleId',
  userId: 'ronUserId',
  email: 'ron@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: ronMediaArray[7]._id,
      mediaItemURL: ronMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[7].type,
      caption: ronMediaArray[7].captions[0],
      subcaption: ronMediaArray[7].subcaptions[2],
    },
    {
      mediaItemId: ronMediaArray[1]._id,
      mediaItemURL: ronMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[1].type,
      caption: ronMediaArray[1].captions[0],
      subcaption: ronMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[6]._id,
      mediaItemURL: ronMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[6].type,
      caption: ronMediaArray[6].captions[0],
      subcaption: ronMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[14]._id,
      mediaItemURL: ronMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[14].type,
      caption: ronMediaArray[14].captions[2],
      subcaption: ronMediaArray[14].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[4]._id,
      mediaItemURL: ronMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[4].type,
      caption: ronMediaArray[4].captions[2],
      subcaption: ronMediaArray[4].subcaptions[1],
    },
    {
      mediaItemId: ronMediaArray[10]._id,
      mediaItemURL: ronMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[10].type,
      caption: ronMediaArray[10].captions[0],
      subcaption: ronMediaArray[10].subcaptions[1],
    }
  ],
  bio: {
    bioItemsId: ronBio._id,
    vitalInfo: { ...ronBio.vitalInfo },
    prompts: [
      { ...ronBio.prompts[0] },
      { ...ronBio.prompts[1] },
      { ...ronBio.prompts[2] }
    ],
    aboutMe: ronBio.aboutMe[0],
    hobbies: [ronBio.hobbies[0], ronBio.hobbies[1], ronBio.hobbies[2], ronBio.hobbies[3], ronBio.hobbies[4] ],
  },
  profileReviews: [
    { ...dumbledoreProfileReviewBumble }
  ],
  mediaItems: [ ...ronMediaArray ],
  bioItems: { ...ronBio },
}

export const ronDatingProfileTinder = {
  _id: 'ronDatingProfileTinderId',
  userId: 'ronUserId',
  email: 'ron@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: ronMediaArray[7]._id,
      mediaItemURL: ronMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[7].type,
      caption: ronMediaArray[7].captions[0],
      subcaption: ronMediaArray[7].subcaptions[2],
    },
    {
      mediaItemId: ronMediaArray[1]._id,
      mediaItemURL: ronMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[1].type,
      caption: ronMediaArray[1].captions[0],
      subcaption: ronMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[6]._id,
      mediaItemURL: ronMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[6].type,
      caption: ronMediaArray[6].captions[0],
      subcaption: ronMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[14]._id,
      mediaItemURL: ronMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[14].type,
      caption: ronMediaArray[14].captions[2],
      subcaption: ronMediaArray[14].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[4]._id,
      mediaItemURL: ronMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[4].type,
      caption: ronMediaArray[4].captions[2],
      subcaption: ronMediaArray[4].subcaptions[1],
    },
    {
      mediaItemId: ronMediaArray[10]._id,
      mediaItemURL: ronMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[10].type,
      caption: ronMediaArray[10].captions[0],
      subcaption: ronMediaArray[10].subcaptions[1],
    }
  ],
  bio: {
    bioItemsId: ronBio._id,
    vitalInfo: { ...ronBio.vitalInfo },
    prompts: [
      { ...ronBio.prompts[0] },
      { ...ronBio.prompts[1] },
      { ...ronBio.prompts[2] }
    ],
    aboutMe: ronBio.aboutMe[0],
    hobbies: [ronBio.hobbies[0], ronBio.hobbies[1], ronBio.hobbies[2], ronBio.hobbies[3], ronBio.hobbies[4] ],
  },
  profileReviews: [
    { ...harryProfileReviewTinder }
  ],
  mediaItems: [ ...ronMediaArray ],
  bioItems: { ...ronBio },
}